<div [class.isPrinting]="printService.isPrinting">

  <div class="row margin-bottom-10px" id="edit-link">
    <div class="col-md-12">
      <div class="card box-shadow-new-treatmentcycle border-left-pickup">
        <div class="card-header wh-header border-bottom-1px padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
          <div class="row nav-link-hand margin-left-0px margin-right-0px background-new-pickup data-color-white">
            <div class="col-md-6 padding-right-0px">
              <label class="margin-bottom-0px font-size-16px font-weight-normal" id="pickup">
                <!--<i class="fas fa-circle light-gray-badge nav-link-hand  ">
                </i>-->
                Pickup
              </label>
            </div>
            <div class="col-md-6  padding-right-0px display-edit">
              <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
              <div class="row  margin-left-0px margin-right-0px" *ngIf="PickupData2 || FollicularPickupEndInfo">
                <!--<div class="offset-md-3 col-md-3" *ngIf="!FollicularPickupEndInfo.IsPickedUp">-->
                  <div class="offset-md-3 col-md-3" *ngIf="PickupData2.ActivityStatus !=='Completed'">
                    <button class="btn actions-btn-prime float-right font-size-15px " type="button" (click)="AddTrigger()">
                      <i class="fas fa-pencil-alt"></i> Add Trigger
                    </button>
                  </div>
                  <div class="col-md-2 padding-left-0px" *ngIf="PickupData2.ActivityStatus !=='Completed'">
                    <!--<a class="nav-link-hand education-navlink  display-edit" title="Edit" (click)="Editpickup()">
      <span class="badge font-size-14 padding-right-0px"><i class="fas fa-pencil-alt"></i></span>
    </a>-->
                    <button type="button" class="btn actions-btn-prime float-right font-size-15px padding-right-0px padding-left-0px min-width-32px" (click)="Editpickup()"><i class="fas fa-pencil-alt"></i></button>
                  </div>
                  <div class="offset-md-6 col-md-2" *ngIf="PickupData2.ActivityStatus =='Completed'">


                    <a class="nav-link-hand education-navlink" title="Detail" (click)="Editpickup()">
                      <span class="badge font-size-16px padding-right-0px"><i class="fa fa-info-circle"></i></span>
                    </a>

                  </div>
                  <div class="col-md-1  padding-left-0px padding-right-0px">
                    <!--<a class="nav-link-hand education-navlink data-color-new" title="To View images">
      <span class="badge font-size-20px padding-left-0px padding-right-0px padding-bottom-0px padding-top-0px"><i class="far fa-image"></i></span>
    </a>-->
                    <!--<a class="nav-link-hand education-navlink" title="print" (click)="printfollicular()">
      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
    </a>-->
                    <button type="button" class="btn actions-btn-prime float-right font-size-15px padding-right-0px padding-left-0px min-width-32px" (click)="printpickup()"><i class="fa fa-print"></i></button>
                  </div>

                  <div class="col-md-1 padding-left-11px">
                    <button type="button" (click)="Top()"
                            class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                            name="upload">
                      <i class="fas fa-arrow-alt-circle-up color-green font-size-18px"></i>
                      <!--<i class="fas fa-long-arrow-alt-up font-size-11"></i>-->
                    </button>
                  </div>
                  <div class="col-md-1 padding-left-11px">
                    <!--<button type="button"
            class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
            name="upload">
      <i class="fas fa-plus font-size-11"></i>
    </button>-->
                    <button type="button" (click)="Bottom()"
                            class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                            name="upload" title="Goto Bottom">
                      <i class="fas fa-arrow-alt-circle-down color-green font-size-18px"></i>
                      <!--<i class="fas fa-long-arrow-alt-down font-size-11 "></i>-->
                    </button>
                  </div>

                </div>




            </div>

          </div>
        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px">
          <div class="row margin-top-0px margin-left-0px margin-right-0px">
            <div class="col-md-4 padding-left-15px padding-right-15px background-white">
              <div class="card  h-100 padding-left-10px">
                <div class="card-header wh-header header-new header-4 font-size-14 card-background-transparent color-ovulation">
                  <i class="fas fa-clock"></i>  Ovulation Trigger1
                </div>
                <div class="card-body padding-top-0px padding-left-8px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 margin-top-5px">
                      <label class="font-size-12px margin-bottom-0px">Date/Time</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12" *ngIf="FollicularPickupEndInfo">
                      <label class="font-size-15px  margin-bottom-5px">{{FollicularPickupEndInfo.OvulationTriggerDate| date:'dd-MMM-yyyy'}},{{FollicularPickupEndInfo.OvulationTriggerTime| slice:11}}</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Medicine</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12" *ngIf="FollicularPickupEndInfo">
                      <label class="font-size-15px margin-bottom-0px font-weight-bold color-cyan">{{FollicularPickupEndInfo.MedicineName}},{{FollicularPickupEndInfo.Dosage}}</label>
                      <div class="row margin-top-7pn">
                        <div class="col-md-3">
                          <label class="font-size-12px margin-bottom-0px">Batch</label>
                        </div>:
                        <div class="col-md-6 padding-left-10px" *ngIf="FollicularPickupEndInfo">
                          <label class="font-size-12px margin-bottom-0px">{{FollicularPickupEndInfo.BatchNo}}</label>
                        </div>

                      </div>
                    </div>
                  </div>
                  <!--<div class="row">
          <div class="col-md-3">
            <label class="font-size-12px margin-bottom-0px">Batch</label>
          </div>:
          <div class="col-md-6 padding-left-10px">
            <label class="font-size-12px margin-bottom-0px">BNJ789</label>
          </div>

        </div>-->

                </div>
              </div>
            </div>
            <div class="col-md-4 padding-left-15px padding-right-15px background-white">
              <div class="card  h-100 padding-left-10px">
                <div class="card-header wh-header header-new header-4 font-size-14 card-background-transparent color-ovulation">
                  <i class="fas fa-clock"></i>  Ovulation Trigger2
                </div>
                <div class="card-body padding-top-0px padding-left-8px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 margin-top-5px">
                      <label class="font-size-12px margin-bottom-0px">Date/Time</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12" *ngIf="FollicularPickupEndInfo">
                      <label class="font-size-15px  margin-bottom-5px">{{FollicularPickupEndInfo.OvulationTriggerDate2| date:'dd-MMM-yyyy'}},{{FollicularPickupEndInfo.OvulationTriggerTime2| slice:11}}</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Medicine</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12" *ngIf="FollicularPickupEndInfo">
                      <label class="font-size-15px margin-bottom-0px font-weight-bold color-cyan">{{FollicularPickupEndInfo.MedicineName2}},{{FollicularPickupEndInfo.Dosage2}}</label>
                      <div class="row margin-top-7pn">
                        <div class="col-md-3">
                          <label class="font-size-12px margin-bottom-0px">Batch</label>
                        </div>:
                        <div class="col-md-6 padding-left-10px" *ngIf="FollicularPickupEndInfo">
                          <label class="font-size-12px margin-bottom-0px">{{FollicularPickupEndInfo.BatchNo2}}</label>
                        </div>

                      </div>
                    </div>
                  </div>
                  <!--<div class="row">
          <div class="col-md-3">
            <label class="font-size-12px margin-bottom-0px">Batch</label>
          </div>:
          <div class="col-md-6 padding-left-10px">
            <label class="font-size-12px margin-bottom-0px">BNJ789</label>
          </div>

        </div>-->

                </div>
              </div>
            </div>
            <div class="col-md-4 background-white">
              <div class="card  h-100">
                <div class="card-header wh-header header-new header-4 font-size-14 card-background-transparent color-team">
                  <i class="fas fa-users"></i> Team
                </div>
                <div class="card-body padding-top-0px padding-left-8px padding-bottom-0px">
                  <!--<div class="row">
          <div class="col-md-12 margin-top-5px">
            <label class="font-size-12px margin-bottom-0px">Surgeon</label>
          </div>

        </div>-->
                  <div class="row margin-top-10">
                    <div class="col-md-4 ">
                      <img class="img-circle-30" src='dummy.jpg'>
                    </div>
                    <div class="col-md-6 padding-left-5px padding-right-0px">
                      <div class="row" *ngIf="FollicularPickupEndInfo">
                        <label class="margin-bottom-0px font-size-13px">{{FollicularPickupEndInfo.SurgeonName}}</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px font-size-11px">Surgeon</label>
                      </div>

                    </div>
                    <!--<div class="col-md-12 margin-top-5px">
            <label class="font-size-15px margin-bottom-0px color-cyan font-weight-bold "><img class="img-circle-30" src='dummy.jpg'> Dr.Asha</label>
            <div>
              <label class="font-size-12px margin-bottom-0px">Surgeon</label>
            </div>
          </div>-->

                  </div>
                  <div class="row margin-top-10">
                    <div class="col-md-4 ">
                      <img class="img-circle-30" src='dummy.jpg'>
                    </div>
                    <div class="col-md-6 padding-left-5px padding-right-0px">
                      <div class="row" *ngIf="FollicularPickupEndInfo">
                        <label class="margin-bottom-0px font-size-13px">{{FollicularPickupEndInfo.AsstSurgeonName}}</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px font-size-11px">{{AsstSurgeon}}</label>
                      </div>

                    </div>
                    <!--<div class="col-md-12 margin-top-5px">
            <label class="font-size-15px margin-bottom-0px color-cyan font-weight-bold "><img class="img-circle-30" src='dummy.jpg'> Dr.Asha</label>
            <div>
              <label class="font-size-12px margin-bottom-0px">Surgeon</label>
            </div>
          </div>-->

                  </div>
                  <div class="row margin-top-10 margin-bottom-5px">
                    <div class="col-md-4 ">
                      <img class="img-circle-30" src='dummy.jpg'>
                    </div>
                    <div class="col-md-6 padding-left-5px padding-right-0px">
                      <div class="row" *ngIf="FollicularPickupEndInfo">
                        <label class="margin-bottom-0px font-size-13px">{{FollicularPickupEndInfo.AnesthesiologistName}}</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px font-size-11px">Anaesthetist</label>
                      </div>

                    </div>
                    <!--<div class="col-md-12 margin-top-5px">
            <label class="font-size-15px margin-bottom-0px color-cyan font-weight-bold "><img class="img-circle-30" src='dummy.jpg'> Dr.Asha</label>
            <div>
              <label class="font-size-12px margin-bottom-0px">Surgeon</label>
            </div>
          </div>-->

                  </div>
                  <!--<div class="row">
          <div class="col-md-12">
            <label class="font-size-12px margin-bottom-0px">Asst.Surgeon</label>
          </div>

        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="font-size-15px margin-bottom-0px ">Dr.Keisham</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="font-size-12px margin-bottom-0px">Anaesthetist</label>
          </div>

        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="font-size-15px margin-bottom-0px">Dr.Madhu</label>
          </div>
        </div>-->
                </div>
              </div>
            </div>
            <div class="col-md-4 ">
              <div class="card  h-100">
                <div class="card-header wh-header header-new header-4 font-size-14 card-background-transparent color-Schedule">
                  <i class="fas fa-clock"></i> Schedule
                </div>
                <div class="card-body padding-top-0px padding-left-8px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 margin-top-5px">
                      <label class="font-size-12px margin-bottom-0px">Planned Time </label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12" *ngIf="FollicularPickupEndInfo">
                      <label class="font-size-15px margin-bottom-5px ">{{FollicularPickupEndInfo.OvumPickupdate| date:'dd-MMM-yyyy'}},{{FollicularPickupEndInfo.OvumPickupdate|date: 'mediumTime'}}</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Actual Time</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12 padding-right-0px" *ngIf="FollicularPickupEndInfo">
                      <label class="font-size-15px margin-bottom-0px color-cyan font-weight-bold ">{{FollicularPickupEndInfo.OvumPlannedPickupDate| date:'dd-MMM-yyyy'}},{{FollicularPickupEndInfo.OvumPlannedPickupDate|date: 'mediumTime'}}</label>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="row margin-top-10">
            <div class="col-md-8 padding-right-0px padding-left-24px">
              <div class="card">
                <div class="card-header color-Assign background-primary padding-top-0px padding-bottom-3px padding-left-3px padding-right-0px font-size-15px border-bottom-1px font-weight-normal">
                  Pickup Sizes
                </div>
                <div class="card-body padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px">
                  <div class="table-component table-processing">
                    <div class="table-responsive overflow-x">


                      <table class="table table-striped margin-left-zero"
                             cols="auto,2*,*,*,*,*,*,*">


                        <tr>

                          <th class="font-weight-normal td-padding-tb background-primary">

                          </th>
                          <!--<th class="text-align-center">Day</th>-->
                          <th class="font-weight-normal td-padding-tb background-primary">
                            Right
                          </th>


                          <th class="font-weight-normal td-padding-tb background-primary">
                            Left
                          </th>
                          <!--<th class="text-align-center">Start Time</th>-->












                        </tr>
                        <tr>
                          <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                            Follicles
                          </th>
                          <td class="td-padding-tb" *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.RFollicleCount}}</td>
                          <td class="td-padding-tb" *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.LFollicleCount}}</td>
                        </tr>
                        <tr>
                          <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                            Aspirated
                          </th>
                          <td class="td-padding-tb" *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.RFollicleAspirated}}</td>
                          <td class="td-padding-tb" *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.LFollicleAspirated}}</td>
                        </tr>
                        <tr>
                          <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                            Oocytes Retrieved
                          </th>
                          <td class="td-padding-tb" *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.TotalRtOocytes}}</td>
                          <td class="td-padding-tb" *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.TotalLtOocytes}}</td>
                        </tr>
                        <tr>
                          <th rowspan="1" class="td-padding-tb background-primary">
                            Total
                          </th>
                          <td class="td-padding-tb font-weight-bold" *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.TotalOocytes}}</td>
                          <!--<td class="td-padding-tb font-weight-bold">6</td>-->
                        </tr>


                        <!--<tbody class="table-body">
                          <tr>

                            <td class="padding-right-0px td-padding-tb align-top">
                              13-JUN-19


                            </td>




                            <td class="td-padding-tb">
                              <div>Day 4 Grading</div>
                              <div class="td-padding-tb td-elipsis2">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.</div>
                            </td>

                            <td class="td-padding-tb text-align-center align-top">
                              <i class="fas fa-circle light-gray-badge nav-link-hand  ">
                              </i>
                            </td>

                          </tr>

                        </tbody>-->

                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card  h-100">
                <div class="card-header wh-header header-new header-4 font-size-14 card-background-transparent color-procedure">
                  <i class="fas fa-bars"></i> Procedure Details
                </div>
                <div class="card-body padding-top-0px padding-left-8px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 margin-top-5px">
                      <label class="font-size-12px margin-bottom-0px">Needle Used</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12" *ngIf="FollicularPickupEndInfo">
                      <label class="font-size-15px margin-bottom-0px font-weight-bold color-cyan">{{FollicularPickupEndInfo.NeedleUsed}}</label>
                    </div>

                  </div>
                  <div class="row margin-top-7pn">
                    <div class="col-md-3">
                      <label class="font-size-12px margin-bottom-5px">Batch</label>
                    </div>:
                    <div class="col-md-6 padding-left-10px">
                      <!--<label class="font-size-12px margin-bottom-0px">BNJ789</label>-->
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Route</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12" *ngIf="FollicularPickupEndInfo">
                      <label class="font-size-15px margin-bottom-5px font-weight-bold color-cyan">{{FollicularPickupEndInfo.Route}}</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Complications</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12" *ngIf="FollicularPickupEndInfo">
                      <label class="font-size-15px margin-bottom-5px">{{FollicularPickupEndInfo.Complications}}</label>
                    </div>
                  </div>

                  <!--<div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Batch</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px">BNJ789</label>
                    </div>
                  </div>-->
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <ivf-additional-detail [CycleCode]='CycleCode'
                                     Title="Additional Information"
                                     Context="PickupAdnlDetail">
              </ivf-additional-detail>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>


  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>
